import { autoserialize } from 'cerialize';
import * as moment from 'moment';

import { Pricing } from './pricing';

export class SponsorshipStatement implements ISponsorshipStatement {
  @autoserialize id?: string;
  @autoserialize current_period?: string;
  @autoserialize balance_start?: number;
  @autoserialize balance_end?: number;
  @autoserialize total_payments?: number;
  @autoserialize total_reserved?: number;
  @autoserialize total_released?: number;
  @autoserialize total_completed?: number;
  period_start?: string;
  period_end?: string;

  constructor(payload?: ISponsorshipStatement) {
    this.id = payload?.id?.toString();
    this.current_period = payload?.current_period;
    this.balance_start = payload?.balance_start;
    this.balance_end = payload?.balance_end;
    this.total_payments = payload?.total_payments;
    this.total_reserved = payload?.total_reserved;
    this.total_released = payload?.total_released;
    this.total_completed = payload?.total_completed;
    this.period_start = moment(this.current_period).startOf('month').format('MMM D, YYYY');
    this.period_end = moment(this.current_period).endOf('month').format('MMM D, YYYY');
  }

  public static OnSerialized(instance: SponsorshipStatement, json: any): void {
    json.balance_start = json.balance_start !== null ? Pricing.formatPrice(json.balance_start * 100) : null;
    json.balance_end = json.balance_end !== null ? Pricing.formatPrice(json.balance_end * 100) : null;
    json.total_payments = json.total_payments !== null ? Pricing.formatPrice(json.total_payments * 100) : null;
    json.total_reserved = json.total_reserved !== null ? Pricing.formatPrice(json.total_reserved * 100) : null;
    json.total_released = json.total_released !== null ? Pricing.formatPrice(json.total_released * 100) : null;
    json.total_completed = json.total_completed !== null ? Pricing.formatPrice(json.total_completed * 100) : null;
  }

  public static OnDeserialized(instance: SponsorshipStatement): void {
    instance.balance_start = instance.balance_start !== null ? Pricing.formatPrice(instance.balance_start / 100) : null;
    instance.balance_end = instance.balance_end !== null ? Pricing.formatPrice(instance.balance_end / 100) : null;
    instance.total_payments = instance.total_payments !== null ? Pricing.formatPrice(instance.total_payments / 100) : null;
    instance.total_reserved = instance.total_reserved !== null ? Pricing.formatPrice(instance.total_reserved / 100) : null;
    instance.total_released = instance.total_released !== null ? Pricing.formatPrice(instance.total_released / 100) : null;
    instance.total_completed = instance.total_completed !== null ? Pricing.formatPrice(instance.total_completed / 100) : null;
  }
}
export interface ISponsorshipStatement {
  id?: string;
  current_period?: string;
  balance_start?: number;
  balance_end?: number;
  total_payments?: number;
  total_reserved?: number;
  total_released?: number;
  total_completed?: number;
}
